import { useMemo, useState } from "react";
import ContentList from "../../../customUiForCs/ContentList";
import ZoneDropDownInput from "../sites/ZoneDropDownInput";
import SiteDropDownInput from "../employees/SiteDropDownInput";
import MaterialInput from "../../../helperComponents/MaterialInput";
import AbsenceCard from "../absence/AbsenceCard";

export default function NomenclatureOfAbsence({
  userID,
  disableFilters,
  inheritedSearchQuery,
  callback,
  tableViewSettings,
}) {
  const [zoneID, setZoneID] = useState(null);
  const [siteID, setSiteID] = useState(null);
  const [date, setDate] = useState(null);

  const queryParams = useMemo(
    () => ({ zoneID, siteID, date }),
    [zoneID, siteID, date]
  );

  return (
    <ContentList
      tableViewSettings={tableViewSettings}
      callback={callback}
      disableFilters={disableFilters}
      inheritedSearchQuery={inheritedSearchQuery}
      //
      userID={userID}
      doReset={() => {
        setZoneID(null);
        setSiteID(null);
        setDate(null);
      }}
      permissionName={"absencePermissions"}
      queryParams={queryParams}
      filters={
        <>
          <MaterialInput
            type="date"
            label={"Date"}
            value={date}
            onChange={(e) => {
              setDate(e.target.value);
            }}
          />
          <SiteDropDownInput onChange={setSiteID} value={siteID} label="Site" />
          <ZoneDropDownInput onChange={setZoneID} value={zoneID} label="Zone" />
        </>
      }
      title="Absences"
      path="absences"
      CardComponent={AbsenceCard}
    />
  );
}
